import './bootstrap';
import ApexCharts from 'apexcharts';

import * as Sentry from "@sentry/browser";

Sentry.init({
    dsn: import.meta.env.VITE_SENTRY_DSN,
    integrations: [
        Sentry.browserTracingIntegration(),
        Sentry.replayIntegration({
            // You can add additional Replay configuration here if needed
        }),
    ],
    tracesSampleRate: 1.0,
    replaysSessionSampleRate: 0.3,
    replaysOnErrorSampleRate: 1.0,
});

window.ApexCharts = ApexCharts;